import React, { useEffect } from "react"
import {
  Route,
  RouteProps,
  Redirect,
  RouteComponentProps,
} from "react-router-dom"
import { connect } from "react-redux"
import { HAuth } from "src/core/helpers"
import { authCheckSavedAuthorized } from "../core/helpers/auth"
interface ReduxProps {
  isAuthenticated: boolean
}
interface Props extends ReduxProps, RouteProps {
  component: React.ComponentType<RouteComponentProps>
}

function AuthenticatedGuard(props: Props) {
  const { isAuthenticated, component: Component, ...rest } = props
  // const isAuthenticated = authCheckSavedAuthorized()
  useEffect(() => {
    const _a = authCheckSavedAuthorized()
    if (_a === false && isAuthenticated === true) {
      window.location.reload()
    }
    // eslint-disable-next-line
  }, [])
  return (
    <Route
      {...rest}
      render={props => {
        if (!isAuthenticated && !HAuth.authIsLogged()) {
          return <Redirect to="/login" />
        }
        return <Component {...props} />
      }}
    />
  )
}

const mapStateToProps = state => ({
  isAuthenticated: state.app.isAuthenticated,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticatedGuard)
